"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIssueValueFromFieldMetadata = exports.DEFAULT_FIELD_ORDER = exports.DEFAULT_BOTTOM_FIELDS = void 0;
var _sdk = require("../../../sdk");
// if there is any data about field order on the type, it will take precedence.
// -- but if any custom or standard fields are not included in the data on the type,
// then those fields will be shown according to this order, after all of the
// fields that ARE in the ordering data on the type.
// In practice, the only time a field should be displayed that wasn't stored in the order
// is probably just custom fields that get added to the type's category,
// or because there's no data at all for the type because the order was not modified.
const DEFAULT_FIELD_ORDER = exports.DEFAULT_FIELD_ORDER = [_sdk.IssueStandardFieldIds.Description, _sdk.IssueStandardFieldIds.Assignee, _sdk.IssueStandardFieldIds.Watchers, _sdk.IssueStandardFieldIds.Location, _sdk.IssueStandardFieldIds.LocationDetails, _sdk.IssueStandardFieldIds.GpsCoordinates, _sdk.IssueStandardFieldIds.DueDate, _sdk.IssueStandardFieldIds.StartDate, _sdk.IssueStandardFieldIds.Placement, _sdk.IssueStandardFieldIds.RootCauseWithCategory, _sdk.IssueStandardFieldIds.Attachments, _sdk.IssueStandardFieldIds.References];

// fields that are shown under the custom fields by default
const DEFAULT_BOTTOM_FIELDS = exports.DEFAULT_BOTTOM_FIELDS = [_sdk.IssueStandardFieldIds.Attachments, _sdk.IssueStandardFieldIds.References];
const getIssueValueFromFieldId = _ref => {
  let {
    fieldId,
    issue
  } = _ref;
  let value;
  if (fieldId === _sdk.IssueStandardFieldIds.Description) {
    value = issue.description;
  } else if (fieldId === _sdk.IssueStandardFieldIds.Assignee) {
    value = issue.assignedTo;
  } else if (fieldId === _sdk.IssueStandardFieldIds.Watchers) {
    value = issue.watchers;
  } else if (fieldId === _sdk.IssueStandardFieldIds.Location) {
    value = issue.locationId;
  } else if (fieldId === _sdk.IssueStandardFieldIds.LocationDetails) {
    value = issue.locationDetails;
  } else if (fieldId === _sdk.IssueStandardFieldIds.DueDate) {
    value = issue.dueDate;
  } else if (fieldId === _sdk.IssueStandardFieldIds.StartDate) {
    value = issue.startDate;
  } else if (fieldId === _sdk.IssueStandardFieldIds.RootCauseWithCategory) {
    value = issue.rootCauseId;
  }
  return value;
};
const getIssueValueFromFieldMetadata = _ref2 => {
  let {
    field,
    issue
  } = _ref2;
  const {
    id: fieldId,
    type
  } = field;
  if (type === "standard") {
    return getIssueValueFromFieldId({
      fieldId: fieldId,
      issue
    });
  } else {
    var _issue$customAttribut;
    const customField = (_issue$customAttribut = issue.customAttributes) === null || _issue$customAttribut === void 0 ? void 0 : _issue$customAttribut.find(_ref3 => {
      let {
        attributeDefinitionId
      } = _ref3;
      return attributeDefinitionId === fieldId;
    });
    return customField === null || customField === void 0 ? void 0 : customField.value;
  }
};
exports.getIssueValueFromFieldMetadata = getIssueValueFromFieldMetadata;
//# sourceMappingURL=issueStandardFields.js.map